import React from 'react';

import { Input } from 'ui-components/components/input';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';
import style from './style.module.less';

/**
 * @param {object} props
 * @param {string} [props.lot]
 * @param {(value: string) => void} props.setLot
 * @returns {JSX.Element}
 */

export const LotInput = ({ lot = '', setLot }) => {
  return (
    <div className={style['input-wrapper']}>
      <Text textType={TextType.Label} value={messages.addToLocationLotLabel} />
      <Input data-testid='lot-input' onChange={setLot} value={lot} />
    </div>
  );
};
